const CONTACT_EMAIL = "afiliaciones@mscrewards.com";

export const formatLocationLabel = (loc) => {
  if (!loc) return "Bolivia";
  const raw = loc.toLowerCase().trim();
  if (['bolivia', 'nacional', 'todos'].includes(raw)) return "Bolivia";
  const locs = loc.split(',').map(l => l.trim()).filter(Boolean);
  return locs.length > 1 ? `${locs[0]} +${locs.length - 1}` : locs[0];
};

export const getExtendedLocation = (loc) => {
  const raw = loc?.toLowerCase().trim();
  if (!raw || ['bolivia', 'nacional', 'todos'].includes(raw)) return "Disponible en toda Bolivia";
  const locs = loc.split(',').map(l => l.trim()).filter(Boolean);
  if (locs.length >= 9) return "Disponible en toda Bolivia";
  return locs.length === 1 ? `Disponible en ${locs[0]}` : `Disponible en ${locs.slice(0, -1).join(', ')} y ${locs.slice(-1)}`;
};

export const formatLocationTags = (locationStr, userCitiesStr) => {
  if (!locationStr) return [];
  
  const userCities = userCitiesStr
    .split(',')
    .map(c => c.trim().toLowerCase());

  return locationStr.split(',').map(loc => {
    const cleanLoc = loc.trim();
    const isMatch = userCities.includes(cleanLoc.toLowerCase()) || cleanLoc.toLowerCase() === 'bolivia';
    
    return {
      label: cleanLoc,
      isMatch: isMatch
    };
  });
};

export const formatDateLabel = (start, end, isDetailed = false) => {
  const opt = { day: '2-digit', month: 'short' };
  const s = new Date(start).toLocaleDateString('es-ES', opt);
  if (!end) return isDetailed ? `Vigente: ${s}` : s;
  const e = new Date(end).toLocaleDateString('es-ES', opt);
  return isDetailed ? `Del ${s} al ${e}` : `${s} - ${e}`;
};

export const parseMarkdown = (txt) => ({
  __html: txt?.replace(/\*\*(.*?)\*\*/g, '<b class="font-black text-msc-dark">$1</b>')
            .replace(/__(.*?)__/g, '<i class="italic">$1</i>')
            .replace(/\n/g, '<br/>')
});

export const triggerCampaignMail = (item) => {
  const dateStr = formatDateLabel(item.starts_at, item.ends_at, true);
  const locationStr = getExtendedLocation(item.location);
  const subject = encodeURIComponent(`PARTICIPAR EN CAMPAÑA: ${item.title}`);
  const body = encodeURIComponent(
    `Enviado a través del Panel de Comercios MSC Rewards,\n\n` +
    `Solicito información para la campaña:\n\n📌 ${item.title}\n📅 ${dateStr}\n📍 ${locationStr}`
  );
  window.location.href = `mailto:${CONTACT_EMAIL}?subject=${subject}&body=${body}`;
};